<!-- Page Header -->
<app-page-header
  title="Kundenübersicht"
  subtitle="Suche und verwalte alle Kundenkonten"
  icon="people"
  variant="gradient">
</app-page-header>

<!-- Search Field -->
<div class="nlc-container nlc-slide-up">
  <div class="nlc-search-card nlc-card">
    <mat-form-field appearance="outline" class="nlc-search-field">
      <mat-label>Suche nach Kunde</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Kundennr, Firma (Kurz), E-Mail..."
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
<div class="nlc-container">
  <div class="nlc-customer-table-card nlc-card">
    <table
      mat-table
      [dataSource]="dataSource"
      class="nlc-customer-table"
    >
    <!-- Customer No Column -->
    <ng-container matColumnDef="customerNo">
      <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">
        Kundennr.
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        {{ customer.customerNo }}
      </td>
    </ng-container>

    <!-- Company Short Name Column -->
    <ng-container matColumnDef="companyShortName">
      <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">
        Firma (Kurz)
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        {{ customer.companyShortName }}
      </td>
    </ng-container>

    <!-- Mail Column -->
    <ng-container matColumnDef="mail">
      <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">
        E-Mail
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        {{ customer.mail }}
      </td>
    </ng-container>

    <!-- Details Column -->
    <ng-container matColumnDef="details">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="global-table-header-cell"
        style="min-width: 90px"
      >
        Details
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        <button
          mat-flat-button
          color="primary"
          class="nlc-details-btn"
          [routerLink]="['/admin/customers/details', customer.customerNo]"
          routerLinkActive="active"
        >
          <span>Details</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="nlc-table-header-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; let i = index; columns: displayedColumns"
      class="nlc-table-row"
    ></tr>
  </table>
  <mat-paginator
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 50]"
    showFirstLastButtons
    class="nlc-paginator"
  ></mat-paginator>
  </div>
</div>
